import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, CheckCircle, XCircle } from "@phosphor-icons/react";
import SantriSelect from "@/components/SantriSelect";
import RowActions from "@/components/RowActions";

const STATUSES = ["pending", "disetujui", "ditolak", "kembali"];

export default function Perizinan() {
  const [items, setItems] = useState([]);
  const [types, setTypes] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [form, setForm] = useState({
    santri: null, jenis_id: "", tanggal_izin: new Date().toISOString().slice(0, 10),
    tanggal_kembali: "", alasan: "", penjemput_nama: "", penjemput_hp: "", penjemput_hubungan: "", status: "pending",
  });

  const load = async () => {
    const { data } = await api.get("/perizinan", { params: { status: statusFilter || undefined } });
    setItems(data);
  };
  useEffect(() => { api.get("/master/perizinan").then((r) => setTypes(r.data)); }, []);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [statusFilter]);

  const submit = async (e) => {
    e.preventDefault();
    const nis = form.santri?.nis;
    if (!nis) { toast.error("Pilih santri terlebih dahulu"); return; }
    try {
      await api.post("/perizinan", { ...form, nis });
      toast.success("Izin dicatat");
      setForm({ ...form, santri: null, alasan: "", penjemput_nama: "", penjemput_hp: "", penjemput_hubungan: "" });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };

  const updateStatus = async (id, status) => {
    try { await api.put(`/perizinan/${id}/status`, null, { params: { status } }); toast.success("Status diperbarui"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };

  return (
    <div className="space-y-5">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400">Divisi Keamanan / Kedisiplinan</div>
        <h1 className="font-display text-3xl font-bold text-[#064E3B]">Perizinan & Penjemputan</h1>
      </div>

      <form onSubmit={submit} className="imsyaf-card p-5 grid md:grid-cols-4 gap-3">
        <div className="md:col-span-2"><label className="text-xs">Santri (cari nama / kamar) *</label>
          <SantriSelect value={form.santri} onChange={(s) => setForm({ ...form, santri: s })} testid="izin-santri" /></div>
        <div className="md:col-span-2"><label className="text-xs">Jenis Izin *</label>
          <select required className="imsyaf-input" value={form.jenis_id} onChange={(e) => setForm({ ...form, jenis_id: e.target.value })} data-testid="izin-jenis">
            <option value="">Pilih…</option>{types.map((t) => <option key={t.id} value={t.id}>{t.nama}</option>)}
          </select></div>
        <div><label className="text-xs">Status Awal</label>
          <select className="imsyaf-input" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
            {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select></div>
        <div><label className="text-xs">Tanggal Izin</label><input type="date" className="imsyaf-input" value={form.tanggal_izin} onChange={(e) => setForm({ ...form, tanggal_izin: e.target.value })} /></div>
        <div><label className="text-xs">Tanggal Kembali</label><input type="date" className="imsyaf-input" value={form.tanggal_kembali} onChange={(e) => setForm({ ...form, tanggal_kembali: e.target.value })} /></div>
        <div className="md:col-span-2"><label className="text-xs">Alasan</label><input className="imsyaf-input" value={form.alasan} onChange={(e) => setForm({ ...form, alasan: e.target.value })} /></div>
        <div><label className="text-xs">Nama Penjemput</label><input className="imsyaf-input" value={form.penjemput_nama} onChange={(e) => setForm({ ...form, penjemput_nama: e.target.value })} /></div>
        <div><label className="text-xs">HP Penjemput</label><input className="imsyaf-input" value={form.penjemput_hp} onChange={(e) => setForm({ ...form, penjemput_hp: e.target.value })} /></div>
        <div><label className="text-xs">Hubungan</label><input className="imsyaf-input" placeholder="Ayah / Ibu / Wali" value={form.penjemput_hubungan} onChange={(e) => setForm({ ...form, penjemput_hubungan: e.target.value })} /></div>
        <div className="md:col-span-4"><button className="imsyaf-btn-primary" data-testid="izin-save-btn"><Plus size={16} /> Simpan Perizinan</button></div>
      </form>

      <div className="imsyaf-card p-4 flex items-end gap-3">
        <div><label className="text-xs">Filter Status</label>
          <select className="imsyaf-input" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="">Semua</option>{STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select></div>
      </div>

      <div className="imsyaf-card overflow-hidden">
        <table className="w-full text-sm zebra">
          <thead className="bg-slate-50"><tr>
            <th className="text-left px-4 py-2">Tanggal</th><th className="text-left px-4 py-2">Santri</th>
            <th className="text-left px-4 py-2">Jenis</th><th className="text-left px-4 py-2">Penjemput</th>
            <th className="text-left px-4 py-2">Alasan</th><th className="text-left px-4 py-2">Status</th><th className="text-right px-4 py-2">Aksi</th>
          </tr></thead>
          <tbody>{items.map((p) => (
            <tr key={p.id} className="border-t border-slate-100">
              <td className="px-4 py-2">{p.tanggal_izin}</td>
              <td className="px-4 py-2"><div className="font-medium">{p.santri_nama}</div><div className="text-xs font-mono text-slate-500">{p.santri_nis}</div></td>
              <td className="px-4 py-2">{p.jenis_nama}</td>
              <td className="px-4 py-2"><div>{p.penjemput_nama || "-"}</div><div className="text-xs text-slate-500">{p.penjemput_hp}</div></td>
              <td className="px-4 py-2 text-slate-500">{p.alasan || "-"}</td>
              <td className="px-4 py-2"><span className={`imsyaf-badge ${p.status === "disetujui" ? "bg-green-100 text-green-800" : p.status === "ditolak" ? "bg-red-100 text-red-700" : p.status === "kembali" ? "bg-blue-100 text-blue-800" : "bg-slate-100"}`}>{p.status}</span></td>
              <td className="px-4 py-2 text-right space-x-1">
                {p.status === "pending" && <>
                  <button className="imsyaf-btn-ghost text-green-700" onClick={() => updateStatus(p.id, "disetujui")}><CheckCircle size={14}/></button>
                  <button className="imsyaf-btn-ghost text-red-700" onClick={() => updateStatus(p.id, "ditolak")}><XCircle size={14}/></button>
                </>}
                {p.status === "disetujui" && <button className="imsyaf-btn-ghost text-blue-700" onClick={() => updateStatus(p.id, "kembali")}>Tandai Kembali</button>}
                <RowActions testid={`izin-${p.id}`}
                  onEdit={null}
                  onDelete={async () => { await api.delete(`/perizinan/${p.id}`); toast.success("Dihapus"); load(); }}
                  confirmText="Hapus perizinan ini?"
                  canEdit={false} />
              </td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-slate-400">Belum ada perizinan.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
